import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Infographic.scss';

gsap.registerPlugin(ScrollTrigger);

function Infographic() {
  const friendsRef = useRef();
  const spaceRef = useRef();

  useEffect(() => {
    ScrollTrigger.matchMedia({
      '(max-width: 767px)': function () {
        const tl2 = gsap.timeline({
          scrollTrigger: {
            trigger: spaceRef.current,
            start: 'top 75%',
            end: 'top 75%',
            once: true
          }
        });
        tl2
          .to('#space', {
            opacity: 1,
            scale: 1.1,
            transformOrigin: 'center center',
            duration: 1
          })
          .to('#space', { scale: 1, duration: 0.3 })
          .to('#windows', { opacity: 1, duration: 1 }, '-=.3');
      },

      '(min-width: 768px)': function () {
        const tl2 = gsap.timeline({
          scrollTrigger: {
            trigger: spaceRef.current,
            start: 'top 75%',
            end: 'top 75%',
            once: true
          }
        });
        tl2
          .to('#space', {
            opacity: 1,
            scale: 1.1,
            transformOrigin: 'center center',
            duration: 1,
            delay: 1
          })
          .to('#space', { scale: 1, duration: 0.3 })
          .to('#windows', { opacity: 1, duration: 1 }, '-=.3');
      }
    });

    const tl1 = gsap.timeline({
      scrollTrigger: {
        trigger: friendsRef.current,
        start: 'top 75%',
        end: 'top 75%',
        once: true
      }
    });
    tl1.fromTo('#friend', { y: 20, x: 20, opacity: 0 }, { y: 0, x: 0, opacity: 1, duration: 1 });
  }, []);

  return (
    <figure className="infographic-section2">
      <div className="infographic__graphic">
        <h3 className="graphic__title">what do sellers want the most?</h3>
        <div className="graphic__sections">
          <div className="graphic__section graphic__sections__section-friends" ref={friendsRef}>
            <svg
              id="Layer_1"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 68 50"
              className="graphic__icon graphic__icon-friends"
            >
              <g id="friend">
                <path
                  className="cls-1"
                  d="M47,43.65H47a141.62,141.62,0,0,0-4.85-15.09c-.75-1.8-3.65-2.59-7.39-2.8l-1.59-.08A14.11,14.11,0,0,0,34.49,23c.44-.06.89-.09,1.38-.12l1.91-.12a14.54,14.54,0,0,0,18.57,0l1.18.06c2.84.15,5,.75,5.6,2.12C65.2,29.78,68,40.87,68,40.87S60.78,43.88,47,43.65Z"
                  transform="translate(0 0.01)"
                />
                <path
                  className="cls-1"
                  d="M47,20.79A10.6,10.6,0,0,1,41.2,19,10.35,10.35,0,0,1,36.71,8.37a10.46,10.46,0,0,1,2.87-5.32A10.55,10.55,0,0,1,55.74,4.61a10.31,10.31,0,0,1,1,9.76A10.41,10.41,0,0,1,51,20a10.62,10.62,0,0,1-4,.8Z"
                  transform="translate(0 0.01)"
                />
              </g>
              <path
                className="cls-1"
                d="M21,27a10.64,10.64,0,0,1-5.9-1.72,10.53,10.53,0,0,1-3.94-4.69A10.44,10.44,0,0,1,13.35,9.13a10.63,10.63,0,0,1,16.3,1.55A10.48,10.48,0,0,1,21,27Zm0,5.36A14.38,14.38,0,0,0,30.22,29L31.4,29c2.83.16,5,.75,5.6,2.13,2.1,4.88,4.9,16,4.9,16s-7.23,3-21,2.79S0,47.92,0,47.92,2.09,36.09,4.19,31.21c.59-1.37,2.77-2,5.6-2.12l1.89-.1A14.45,14.45,0,0,0,21,32.35Z"
                transform="translate(0 0.01)"
              />
            </svg>

            <div className="graphic__section__number">#1</div>
            <p className="graphic__section__copy">Want to move closer to friends or family</p>
          </div>
          <div className="graphic__divider" />
          <div className="graphic__section" ref={spaceRef}>
            <svg
              id="space"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 45 46"
              className="graphic__icon graphic__icon-house"
            >
              <path
                className="cls-1"
                d="M44.64,22l-4.31-4.39V4.26a1.21,1.21,0,0,0-1.19-1.21H33a1.21,1.21,0,0,0-1.19,1.21V9L23.37.37a1.19,1.19,0,0,0-1.72,0L.39,22a1.2,1.2,0,0,0,.81,2.08H5.45V44.74A1.26,1.26,0,0,0,6.69,46h31.7a1.26,1.26,0,0,0,1.24-1.26V24.09h4.2A1.21,1.21,0,0,0,44.64,22Z"
                transform="translate(0 0)"
              />
              <g id="windows">
                <rect className="cls-2" x="24.13" y="23.92" width="6.46" height="6.57" />
                <rect className="cls-2" x="14.44" y="23.92" width="6.46" height="6.57" />
                <rect className="cls-2" x="14.44" y="33.78" width="6.46" height="6.57" />
                <rect className="cls-2" x="24.13" y="33.78" width="6.46" height="6.57" />
              </g>
            </svg>

            <div className="graphic__section__number">#2</div>
            <p className="graphic__section__copy">Want to move due to retirement</p>
          </div>
        </div>
      </div>
      <figcaption className="captions">
        Source: NAR, Profile of Home Buyers and Sellers, 2022
      </figcaption>
    </figure>
  );
}

export default Infographic;
